/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import Vue from 'vue';
import VueRouter from 'vue-router';
import router from './router.js';
import BottomNav from './components/BottomNav';
import store from './store.js';
import DataSet from './components/DataSet';
import VuePlyr from 'vue-plyr';
import EventBus from './eventbus.js';
import 'vue-plyr/dist/vue-plyr.css';
import ToggleButton from 'vue-js-toggle-button';
import VueMasonry from 'vue-masonry-css';

Vue.config.productionTip = false

window.Vue = Vue;

Vue.use(ToggleButton)
Vue.use(VueRouter);
Vue.use(VueMasonry);
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */


const app = new Vue({
    router,
    store,
    el: '#app',
    data: function() {
        return {
            title: 'Cerner Value Portal'
        }
    },
    mounted() {
        this.checkIsMobile();

        const self = this;

        window.addEventListener('resize', function() {
            self.checkIsMobile();

            EventBus.$emit('resize', window.innerWidth);
        })
    },
    created() {
        EventBus.$on( 'gtag', (event) => {
            // production set in vuex based on url
            if ( this.$store.getters.production ) {
                window.gtag('event', event.action, event.details);
            }
        })
    },
    computed: {
        category() {
            return this.$store.getters.category;
        }
    },
    methods: {
        appKeyEsc() {
            EventBus.$emit('app.key.esc', 'esc');
        },
        checkIsMobile() {
            if ( window.innerWidth < this.$store.getters.mobileWidth ) {
                this.$store.commit('updateIsMobile', true);
            } else {
                this.$store.commit('updateIsMobile', false);
            }

            if ( window.innerWidth < 480 ) {
                EventBus.$emit('mobileSmall', true);
            } else {
                EventBus.$emit('mobileSmall', false);
            }
        }
    },
    components: {
        BottomNav,
        DataSet
    }
});

jQuery(document).ready(function($) {
    $('.js-init-video').magnificPopup({
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $('video').trigger('pause');
          },
          close: function() {
            $('video').trigger('play');
          }
        }
    });

    if ( $('.js-match-card-height').length > 0 ) {
        $('.js-match-card-height .card').matchHeight();
    }

    // window.resizeGridItem = function( item ){
    //     let grid = document.getElementsByClassName("card-grid")[0];
    //     let rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
    //     let rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));

    //     grid.style.gridAutoRows = "auto";
    //     grid.style.alignItems = "self-start";
    //     grid.querySelectorAll(".card-grid-col").forEach(item => {
    //       item.style.gridRowEnd = `span ${Math.ceil(
    //         (item.clientHeight + rowGap) / (rowHeight + rowGap)
    //       )}`;
    //     });
    //     grid.removeAttribute("style");

    // }

    // window.resizeAllGridItems = function(){
    //     let allItems = document.getElementsByClassName("card-grid-col");

    //      for(let x=0;x<allItems.length;x++){
    //       resizeGridItem(allItems[x]);
    //     }
    // }

    // window.onload = resizeAllGridItems();
    // window.addEventListener("resize", resizeAllGridItems);

});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js